import {
  useSuspenseQuery,
  type UseSuspenseQueryOptions,
} from '@tanstack/react-query';
import type { GetUserResponse } from 'generated/openapi';

import { getMyUserKey, getMyUserOptions } from './getMyUser.options';

export interface UseGetMyUserProps<T = GetUserResponse> {
  options?: Omit<
    UseSuspenseQueryOptions<GetUserResponse, unknown, T>,
    'queryKey' | 'queryFn'
  >;
}

export function useGetMyUser<T = GetUserResponse>(props: UseGetMyUserProps<T>) {
  const { options } = props;

  return useSuspenseQuery({
    ...getMyUserOptions<T>(),
    ...options,
  });
}

useGetMyUser.getQueryKey = getMyUserKey;
